import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mountVernonConfig } from "./data";

export default function MountVernonPage() {
  return <CityPageTemplate config={mountVernonConfig} />;
}